import { Component, Input } from '@angular/core';

@Component({
  selector: 'mfp-circular-indicator',
  templateUrl: './circular-indicator.component.html',
  styleUrls: ['./circular-indicator.component.scss']
})
export class CircularIndicatorComponent {
  readonly size = 74;
  readonly viewBox = `0 0 ${this.size} ${this.size}`;
  readonly stroke = 10;
  readonly middle = this.size / 2;
  readonly radius = (this.size - this.stroke) / 2;
  readonly circumference = this.radius * 2 * Math.PI;
  readonly dashArray = `${this.circumference} ${this.circumference}`;

  @Input() basePercentage = 0;
  @Input() currentPercentage = 0;

  getDashOffset(percentage: number): number {
    return this.circumference - (percentage / 100) * this.circumference;
  }

  capShouldBeVisible() {
    return this.currentPercentage > this.basePercentage && this.currentPercentage > 94;
  }
}
